import React, { useContext, useEffect, useRef, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import AddBoxIcon from "@material-ui/icons/AddBox";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import sortReversedIcon from "../../assets/sortReversedIcon.png";
import sortIcon from "../../assets/sortIcon.png";

import {
	Box,
	CircularProgress,
	IconButton,
	Menu,
	Tooltip,
} from "@material-ui/core";

import NewTicketModal from "../NewTicketModal";
import TabPanel from "../TabPanel";

import { AuthContext } from "../../context/Auth/AuthContext";
import TicketsQueueSelect from "../TicketsQueueSelect";
import useAppDarkMode from "../../hooks/useAppDarkMode";
import useTicketTabBadgeCounts from "../../hooks/useTicketTabBadgeCounts";
import api from "../../services/api";
import { isStatusPerfilEnabled } from "../../helpers/statusPerfilSetting";
import openSocket from "../../services/socket-io";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import TicketsTagSelect from "../TicketsTagSelect";
import ChatLayoutToggle from "../ChatLayout/ChatLayoutToggle";
import TailwickChatsHeader from "../../pages/Tickets/TailwickChatsHeader";
import TailwickTicketListPanels, {
	LegacyTicketListPanels,
} from "../../pages/Tickets/TailwickTicketListPanels";
import ModalSelect from "../../components/ModalSelect";
import RecentTicketSearches from "../RecentTicketSearches";
import { ChannelFilters } from "../../helpers/ticketFilters";
import useRecentTicketSearches from "../../hooks/useRecentTicketSearches";

const useStyles = makeStyles((theme) => ({
	ticketsWrapper: {
		background: theme.palette.background.default,
		position: "relative",
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflow: "hidden",
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderLeft: "0"
	},

	managerTopBar: {
		padding: "6px 12px 6px 10px",
		width: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-start",
		alignItems: "center",
		gap: 8,
		flexShrink: 0,
		minHeight: 52,
		boxSizing: "border-box",
	},

	tabsHeader: {
		// width: "100%",
		display: "flex",
		// flex: "none",
		// backgroundColor: `${!darkMode ? "" : "#f0f2f5"}`,
		height: 59,
		padding: "16 0px",
	},

	settingsIcon: {
		alignSelf: "center",
		marginLeft: "auto",
		padding: 8,
	},

	tab: {
		padding: "0 20px",
		marginLeft: 10,
		marginTop: "-5px",
		top: 0,
		minWidth: 20,
		width: 20,
		height: 20,
	},

	closedTab: {
		padding: "0 20px",
		marginLeft: 10,
		marginTop: "-7px",
		top: 0,
		minWidth: 20,
		width: 20,
		height: 20,
	},

	ticketOptionsBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		// background: `${!darkMode ? "" : "#f0f2f5"}`,
		padding: theme.spacing(1),
	},

	searchContainer: {
		position: "relative",
		zIndex: 6,
		display: "flex",
		flexDirection: "column",
		padding: "0 0.5rem",
		marginBottom: 5
	},

	searchInputWrapper: {
		position: "relative",
		flex: 1,
		// background: `${!darkMode ? "" : "#f0f2f5"}`,
		display: "flex",
		borderRadius: 30,
		padding: 6,
		margin: 7,
		gap: 10
	},

	searchIcon: {
		fontSize: "1.4em",
		marginLeft: 6,
		alignSelf: "center",
	},

	filterIconFalse: {
		border: "1px solid #D5D2D1 ",
		cursor: "pointer",
		borderRadius: "30px",
		padding: "0.9rem 0.7rem",
		width: "auto",
		height: 30,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginRight: 5,
		color: "#6D6D6C",
		fontWeight: 600,

		"&:hover": {
			background: "#FFFFFF20"
		},
		// svg font size
		"& > svg": {
			fontSize: "1.4em",
		},
	},

	filterIconTrue: {
		border: "1px solid #D5D2D1",
		fontWeight: "600",
		backgroundColor: "#D9FDD3",
		color: "#3C7D59",
		cursor: "pointer",
		borderRadius: "30px",
		padding: "0.9rem 0.7rem",
		width: "auto",
		height: 30,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginRight: 5,

		"& > svg": {
			fontSize: "1.4em",
		},
	},

	searchInput: {
		fontSize: "1em",
		flex: 1,
		border: "none",
		borderRadius: 30,
	},
	focused: {
		outline: "2px solid #30AA61",
		backgroundColor: "#ffff !important",
		color: "gray"
	},
	ativo: {
		color: "gray"
	},

	selectedTab: {
		color: "#009688",
	},

	newTicketBtn: {
		// color: `${!darkMode ? "#fbfbfc" : "#757575"}`,
		margin: "14px 5px 0 16px",
		cursor: "pointer",
	},

	FiltroSearch: {
		display: "flex",
		marginLeft: 10
	},


	badge: {
		margin: 0,
		top: "-10px",
		right: "-10px",
		padding: 0,
		// position: "absolute",

		"& > span": {
			width: 20,
			height: 20,
			borderRadius: "50%",
			backgroundColor: "#ff0063",
			color: "#fff",
			fontSize: "0.9em",
			fontWeight: 600,
		},
	},

	show: {
		display: "block",
	},

	hide: {
		display: "none !important",
	},
}));

function TicketsManager({ tailwickLayout = false }) {

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const [filterModalOpen, setFilterModalOpen] = useState(false);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const classes = useStyles();
	const [isFocused, setIsFocused] = useState(false);
	const [isAtivo, setAtivo] = useState(false);
	const [searchParam, setSearchParam] = useState("");
	const [searched, setSearched] = useState(0);
	const [searchLoading, setSearchLoading] = useState(false);
	const [tab, setTab] = useState("open");
	const [tabOpen, setTabOpen] = useState("open");
	const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
	const [showAllTickets, setShowAllTickets] = useState(true);
	const searchInputRef = useRef();
	const { user } = useContext(AuthContext);
	const {
		items: recentSearches,
		add: addRecentSearch,
		remove: removeRecentSearch,
		clear: clearRecentSearches,
	} = useRecentTicketSearches(user?.id);

	const [, setStatusCount] = useState(0);
	const [statusPerfilEnabled, setStatusPerfilEnabled] = useState(false);
	const [tags, setTags] = useState([]);
	const [showUnread, setShowUnread] = useState(false);
	const [sortOrder, setSortOrder] = useState({
		sortByOpen: '',
		sortByPending: '',
		sortByClosed: ''
	});


	useEffect(() => {
		const fetchSession = async () => {
			try {

				const listTags = await api.get("/tags/list");

				setTags(listTags.data);

					const { data } = await api.get("/settings");

					setStatusPerfilEnabled(isStatusPerfilEnabled(data));

					const getSetting = (key) => data.find((s) => s.key === key)?.value || '';

					setSortOrder({
						sortByOpen: getSetting("sortByOpen"),
						sortByPending: getSetting("sortByPending"),
						sortByClosed: getSetting("sortByClosed")
					});
			} catch (err) {
				setSortOrder({
					sortByOpen: 'desc',
					sortByPending: 'desc',
					sortByClosed: 'desc'
				});
			}
		};
		fetchSession();
	}, []);

	useEffect(() => {
		if (!user?.id) return undefined;

		const socket = openSocket({
			scope: "ticketsmanager-settings",
			userId: user.id,
			component: "TicketsManager",
			companyId: user.companyId ?? "",
		});
		if (!socket) return undefined;

		socket.on("settings", (data) => {
			if (data.action !== "update" || !data.setting) return;
			if (data.setting.key !== "StatusPerfil") return;

			const sid = data.setting.companyId;
			if (
				sid != null &&
				user.companyId != null &&
				Number(sid) !== Number(user.companyId)
			) {
				return;
			}

			setStatusPerfilEnabled(data.setting.value === "enabled");
		});

		return () => {
			socket.disconnect();
		};
	}, [user.companyId, user.id]);

	const userQueueIds = user.queues?.map((q) => q.id) || [];
	const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds);

	// user.queues pode chegar depois do mount — sem isso o filtro fica [] e o WS libera tudo.
	const userQueueIdsKey = userQueueIds.join(",");
	useEffect(() => {
		if (!userQueueIdsKey) return;
		const ids = userQueueIdsKey.split(",").map((id) => {
			const n = Number(id);
			return Number.isNaN(n) ? id : n;
		});
		setSelectedQueueIds((prev) => {
			if (Array.isArray(prev) && prev.length > 0) return prev;
			return ids;
		});
	}, [userQueueIdsKey]);

	const [selectedTagIds, setSelectedTagIds] = useState([]);

	const [selectedChannels, setSelectedChannels] = useState([]);

	const [bulkSelection, setBulkSelection] = useState(false);
	const [bulkSelected, setBulkSelected] = useState([]);

	const {
		openCount: openBadgeCount,
		pendingCount: pendingBadgeCount,
		openUnreadMessagesSum,
	} = useTicketTabBadgeCounts({
		userId: user?.id,
		companyId: user?.companyId,
		showAllTickets: showAllTickets ? "true" : undefined,
		queueIdsParam: JSON.stringify(selectedQueueIds),
		tagsIdsParam: JSON.stringify(selectedTagIds),
		channelsParam: JSON.stringify(selectedChannels),
		userQueues: user?.queues,
		canSeeAllTickets: user?.canSeeAllTickets,
		canSeeGroups: user?.canSeeGroups,
	});

	const appDarkMode = useAppDarkMode();
	const legacyDarkMode = localStorage.getItem("darkMode") === "true";
	const darkMode = tailwickLayout ? appDarkMode : legacyDarkMode;
	const panelBg = tailwickLayout
		? undefined
		: { backgroundColor: darkMode ? "#1b1d1d" : "#ffff" };
	const tabColor = tailwickLayout
		? undefined
		: { color: darkMode ? "#fff" : "#000000" };
	const searchBg = tailwickLayout
		? undefined
		: { backgroundColor: darkMode ? "#343636" : "#F6F6F5" };

	useEffect(() => {
		if (user.profile?.toUpperCase() === "ADMIN") {
			setShowAllTickets(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(()=>{
		setBulkSelected([]);
	},[bulkSelection])

	useEffect(() => {
		if (!statusPerfilEnabled && (tab === "status" || tabOpen === "status")) {
			setTab("open");
			setTabOpen("open");
		}
	}, [statusPerfilEnabled, tab, tabOpen]);

	useEffect(() => {
		setSearchParam("");
		setBulkSelection(false)
	}, [tabOpen, tab]);

	useEffect(() => {
		if (searchParam === "") {
			setSearched(0);
			setSearchLoading(false);
		}
	}, [searchParam]);

	const commitTicketSearch = (raw) => {
		const term = String(raw || "").trim();
		if (!term) return;

		setSearchParam(term);
		addRecentSearch(term);
		setSearched((n) => n + 1);
		setSearchLoading(true);
	};

	const handleChangeTab = (e, newValue) => {
		setTab(newValue);
	};

	const applyPanelStyle = (status) => {
		if (tabOpen !== status) {
			return { width: 0, height: 0 };
		}
	};

	const handleSortChange = (tab) => {
		const sortField =
			tab === "open" ? sortOrder.sortByOpen :
				tab === "pending" ? sortOrder.sortByPending :
					tab === "closed" ? sortOrder.sortByClosed : null;

		if (tab === "open") {
			setSortOrder({
				sortByOpen: sortField === 'asc' ? 'desc' : 'asc',
				sortByPending: sortOrder.sortByPending,
				sortByClosed: sortOrder.sortByClosed
			});
		} else if (tab === "pending") {
			setSortOrder({
				sortByOpen: sortOrder.sortByOpen,
				sortByPending: sortField === 'asc' ? 'desc' : 'asc',
				sortByClosed: sortOrder.sortByClosed
			});
		} else if (tab === "closed") {
			setSortOrder({
				sortByOpen: sortOrder.sortByOpen,
				sortByPending: sortOrder.sortByPending,
				sortByClosed: sortField === 'asc' ? 'desc' : 'asc'
			});
		}
	};

	const getSortTooltip = (tab, sortOrder) => {
		const sortField =
			tab === "open" ? sortOrder.sortByOpen :
				tab === "pending" ? sortOrder.sortByPending :
					tab === "closed" ? sortOrder.sortByClosed : null;

		return sortField === 'asc' ? "Ordenar tickets (mais antigos)" : "Ordenar tickets (mais recentes)";
	};

	const getSortIcon = (tab, sortOrder, darkMode) => {
		const sortField =
			tab === "open" ? sortOrder.sortByOpen :
				tab === "pending" ? sortOrder.sortByPending :
					tab === "closed" ? sortOrder.sortByClosed : null;

		const icon = sortField === 'asc' ? sortIcon : sortReversedIcon;
		const color = darkMode ? "#ffff" : "#6e6f70";

		return <img src={icon} alt="Sort" width={24} height={24} color={color} />;
	};

	useEffect(() => {
		const total =
			(parseInt(openBadgeCount, 10) || 0) +
			(parseInt(pendingBadgeCount, 10) || 0);

		if (total > 40) {

			document.title = `(${total}+) ${process.env.REACT_APP_NOME}`
		} else if (total === 0) {
			document.title = ` ${process.env.REACT_APP_NOME}`
		} else {
			document.title = `(${total}) ${process.env.REACT_APP_NOME}`;
		}

	}, [openBadgeCount, pendingBadgeCount]);

	const listPanelProps = {
		tab,
		searched,
		searchParam,
		showAllTickets,
		showUnread,
		selectedQueueIds,
		selectedTagIds,
		sortOrder,
		setStatusCount,
		setSearchLoading,
		applyPanelStyle,
		statusPerfilEnabled,
		selectedChannels,
		bulkSelection,
		setBulkSelection,
		bulkSelected,
		setBulkSelected
	};

	const listColumn = (
		<>
			<NewTicketModal
				modalOpen={newTicketModalOpen}
				onClose={(e) => setNewTicketModalOpen(false)}
			/>
			{!tailwickLayout && (
			<Box className={classes.managerTopBar} style={panelBg}>
				<div
					style={{
						flexShrink: 0,
						maxWidth: 200,
						minWidth: 0,
						overflow: "hidden",
					}}
				>
					<ChatLayoutToggle compact />
				</div>

				<Paper
					elevation={0}
					square
					className={classes.tabsHeader}
					style={{
						flex: 1,
						minWidth: 0,
						...(panelBg || {}),
					}}
				>
					<Tabs style={tabColor}
						value={tab}
						onChange={handleChangeTab}
						variant="fullWidth"
						textColor="primary"
						aria-label="icon label tabs example"
					>
						<Tab style={tabColor}
							classes={{ root: classes.tab }}
							icon={
								<Tooltip title="Tickets abertos">
									<ChatBubbleOutlineIcon />
								</Tooltip>
							}
							label={
								<Badge
									overlap="rectangular"
									className={classes.badge}
									badgeContent={openBadgeCount}
								></Badge>
							}
							value="open"
							onClick={() => setTabOpen("open")}
						/>

						<Tab style={tabColor}
							classes={{ root: classes.tab }}
							icon={
								<Tooltip title="Tickets pendentes">
									<AnnouncementIcon />
								</Tooltip>
							}
							label={
								<Badge
									overlap="rectangular"
									className={classes.badge}
									badgeContent={pendingBadgeCount}
									color="primary"
								></Badge>
							}
							value="pending"
							onClick={() => setTabOpen("pending")}
						/>

						{/* {statusPerfilEnabled && (
						<Tab style={tabColor}
							classes={{ root: classes.tab }}
							icon={
								<Tooltip title="Status do WhatsApp">
									<AccountCircle />
								</Tooltip>
							}
							label={
								<Badge
									overlap="rectangular"
									className={classes.badge}
									// badgeContent={statusCount}
									color="primary"
								></Badge>
							}
							value="status"
							onClick={() => setTabOpen("status")}
						/>
						)} */}

						<Tab style={tabColor}
							value="closed"
							icon={
								<Tooltip title="Tickets fechados">
									<CheckBoxIcon />
								</Tooltip>
							}
							label={
								<Badge
									overlap="rectangular"
									className={classes.badge}
									badgeContent={0}
									color="primary"
								></Badge>
							}
							classes={{ root: classes.closedTab }}
						/>

						{/* <Can
							role={user.profile}
							perform="drawer-admin-items:view"
							yes={() => (
								<Tab
									style={{ color: darkMode ? "#fff" : "#000000", top: 7 }}
									classes={{ root: classes.tab }}
									icon={
										<Tooltip title="Funil de vendas">
											<ViewWeekIcon />
										</Tooltip>
									}
									value="sales-funnel"
									onClick={() => {
										window.location.href = "/sales-funnel";
									}}
								/>
							)}
						/> */}
					</Tabs>

					<Box component="span" display="flex" alignItems="center">
						<IconButton onClick={handleClick}>
							<MoreVertIcon style={tabColor} />
						</IconButton>

						<Menu
						  disableAutoFocusItem
							disableAutoFocus
							disableEnforceFocus
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "right",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}} getContentAnchorEl={null}

							PaperProps={{
								style: {
									marginTop: 10,
								},
							}}
						>
							<Box
								className={classes.newTicketBtn}
								style={{
									color: `${darkMode ? "#c7c7c7" : "#6e6f70"}`,
								}}
								onClick={() => setNewTicketModalOpen(true)}
							>
								<Tooltip title="Nova Conversa">
									<AddBoxIcon />
								</Tooltip>
							</Box>
							<Box
								className={classes.newTicketBtn}
								style={{
									padding: 8,
									display: "flex",
									alignItems: "center",
									color: `${darkMode ? "#c7c7c7" : "#6e6f70"}`,
								}}
								onClick={() => {
									handleSortChange(tab);
									handleClose();
								}}
							>
								<Tooltip title={getSortTooltip(tab, sortOrder)}>
									{(tab === "open" || tab === "pending" || tab === "closed") &&
										getSortIcon(tab, sortOrder, darkMode)}
								</Tooltip>
							</Box>

							<Box
								className={classes.newTicketBtn}
								style={{
									padding: 8,
								}}
							>
								<Tooltip title="Filtro de setores">
									<TicketsQueueSelect
										style={{ marginLeft: 6 }}
										selectedQueueIds={selectedQueueIds}
										userQueues={user?.queues}
										setSelectedQueueIds={setSelectedQueueIds}
									/>
								</Tooltip>
							</Box>

							<Box
								className={classes.newTicketBtn}
								style={{
									padding: 8,
								}}
							>
								<Tooltip title="Filtro por tags">
									<TicketsTagSelect
										style={{ marginLeft: 6 }}
										selectedTagIds={selectedTagIds}
										tags={tags}
										setSelectedTagIds={setSelectedTagIds}
									/>
								</Tooltip>
							</Box>

							<Box
								className={classes.newTicketBtn}
								style={{
									padding: 8,
								}}
							>
								<Tooltip title="Filtro por canal">
									<ModalSelect
										style={{ marginLeft: 6 }}
										listItens={ChannelFilters()}
										selected={selectedChannels}
										setSelected={setSelectedChannels}
										title = "Filtro por canal"
										iconExib = "ChatBubble"
									/>
								</Tooltip>
							</Box>
						</Menu>
					</Box>


				</Paper>
			</Box>
			)}

			<TabPanel className={classes.ticketsWrapper}>
				{!tailwickLayout && (
				<Box className={classes.searchContainer}>
					<div
						className={`${classes.searchInputWrapper} tailwick-chat-search ${isFocused ? classes.focused : ""}`}
						style={searchBg}
					>
						<SearchIcon className={classes.searchIcon} />
						<InputBase
							className={`${classes.searchInput} ${isAtivo ? classes.ativo : ""}`}
							inputRef={searchInputRef}
							placeholder={"Pesquisar ou começar uma conversa"}
							type="search"
							value={searchParam}
							autoComplete="off"
							onFocus={() => {
								setIsFocused(true);
								setAtivo(true);
							}}
							onBlur={() => {
								setIsFocused(false);
								setAtivo(false);
							}}
							onChange={(e) => setSearchParam(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									commitTicketSearch(e.target.value);
								}
							}}
							// loading on end of input
							endAdornment={
								searchLoading &&
								searched > 0 && (
									<CircularProgress style={{ color: "#009688" }} size={20} />
								)
							}
						/>
						<RecentTicketSearches
							open={isFocused && !searchParam.trim()}
							items={recentSearches}
							dark={darkMode}
							onSelect={commitTicketSearch}
							onRemove={removeRecentSearch}
							onClear={clearRecentSearches}
						/>
					</div>
					{tabOpen === "open" ?
						<Box className={classes.FiltroSearch} >


							<Box
								className={
									showUnread ? classes.filterIconFalse : classes.filterIconTrue
								}
								onClick={() => {
									setShowUnread(false);
								}}
							>
								<p>Tudo</p>
							</Box>

							<Box
								className={
									showUnread === true ? classes.filterIconTrue : classes.filterIconFalse
								}
								onClick={() => {
									setShowUnread(true);
								}}
							>
								<p>Não lidas</p>
							</Box>

							<Box
								className={
									showUnread === "grupos" ? classes.filterIconTrue : classes.filterIconFalse
								}
								onClick={() => {
									setShowUnread("grupos");
								}}
							>
								<p>Grupos</p>
							</Box>

						</Box> : ""
					}

				</Box>
				)}

				<LegacyTicketListPanels {...listPanelProps} />

			</TabPanel>
		</>
	);

	if (tailwickLayout) {
		const filterRailProps = {
			tab,
			setTab,
			setTabOpen,
			openCount: openBadgeCount,
			pendingCount: pendingBadgeCount,
			statusPerfilEnabled,
			filterModalOpen,
			onFilterModalOpen: () => setFilterModalOpen(true),
			onFilterModalClose: () => setFilterModalOpen(false),
			onSort: handleSortChange,
			sortOrder,
			user,
			selectedQueueIds,
			setSelectedQueueIds,
			selectedTagIds,
			setSelectedTagIds,
			tags,
			selectedChannels,
			setSelectedChannels,
		};

		return (
			<div className="tailwick-tickets-left flex h-full min-h-0 w-full">
				<div className="tailwick-chats-column flex h-full min-w-0 flex-1 flex-col overflow-hidden ticket-body">
					<NewTicketModal
						modalOpen={newTicketModalOpen}
						onClose={() => setNewTicketModalOpen(false)}
					/>
					<TailwickChatsHeader
						tab={tab}
						showUnread={showUnread}
						setShowUnread={setShowUnread}
						searchParam={searchParam}
						onSearchChange={(e) => setSearchParam(e.target.value)}
						onSearchEnter={commitTicketSearch}
						searchLoading={searchLoading}
						searched={searched}
						onNewTicket={() => setNewTicketModalOpen(true)}
						openUnreadMessagesSum={openUnreadMessagesSum}
						setBulkSelection={setBulkSelection}
						bulkSelection={bulkSelection}
						recentSearches={recentSearches}
						onSelectRecent={commitTicketSearch}
						onRemoveRecent={removeRecentSearch}
						onClearRecents={clearRecentSearches}
						darkMode={darkMode}
						filterRailProps={filterRailProps}
					/>
					<div className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
						<TailwickTicketListPanels {...listPanelProps} />
					</div>
				</div>
			</div>
		);
	}

	return (
		<Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
			{listColumn}
		</Paper>
	);
}

export default TicketsManager;
